import { inputSliceActions } from '../../../../features/input/inputSlice';
import Team from '../../../../interfaces/team';

const selectOnChange = (option, team: Team | null, dispatch, intl, notOnTheField?: boolean) => {
  const selectConfirm = intl.formatMessage({ id: 'field.selectConfirm' });
  const selectConfirmPlayerOn = intl.formatMessage({ id: 'field.selectConfirm.playerOn' });
  const selectConfirmPlayerOnSubstituted = intl.formatMessage({ id: 'field.selectConfirm.playerOnSubstituted' });
  if (option && option.value) {
    let onTheField = true;
    let offTheField = true;

    if (team) {
      let isStaff = false;
      if (team.staff && team.staff.length > 0) {
        team.staff.forEach((person) => {
          if (person.id === option.value) {
            dispatch(inputSliceActions.setSelectValue(option ? option!.value : null));
            isStaff = true;
          }
        });
      }
      if (!isStaff) {
        team.persons.forEach((person) => {
          if (person.personId === option.value) {
            if (
              notOnTheField &&
              (person.currentlyOnTheField || (person.entersFieldMinute && person.leavesFieldMinute))
            ) {
              offTheField = false;
              const answer = confirm(
                person.name +
                  (person.entersFieldMinute && person.leavesFieldMinute
                    ? selectConfirmPlayerOnSubstituted
                    : selectConfirmPlayerOn),
              );
              if (answer) {
                dispatch(inputSliceActions.setSelectValue(option ? option!.value : null));
              }
            } else if (!notOnTheField && !person.currentlyOnTheField) {
              onTheField = false;
              const answer = confirm(person.name + selectConfirm);
              if (answer) {
                dispatch(inputSliceActions.setSelectValue(option ? option!.value : null));
              }
            }
          }
        });

        if (notOnTheField && offTheField) {
          dispatch(inputSliceActions.setSelectValue(option ? option!.value : null));
        } else if (!notOnTheField && onTheField) {
          dispatch(inputSliceActions.setSelectValue(option ? option!.value : null));
        }
      }
    }
  } else {
    dispatch(inputSliceActions.setSelectValue(null));
  }
};

export default selectOnChange;
